import { useEffect, useRef, useState } from "react";
import { api } from "../lib/api";

// THÈMES SAISONNIERS (demande du propriétaire, 2026-10-27) : à chaque
// chargement, le site demande le thème actif (Halloween, Noël…) au serveur et
// pose sa palette sur les variables CSS du site (--mt-*, définies dans
// tailwind.config.js avec valeurs par défaut inchangées) + une couche
// décorative en CSS pur (aucune image, aucun tiers). Hors période : rien ne
// change. Le thème se règle dans Admin → Aperçu ; les palettes sont composées
// par l'IA et retouchables à la main.
// 2026-10-27 (suite) : « TOUTES les options doivent rendre le site plus
// festif » — décors riches et visibles ; « Appliquer maintenant » force un
// thème hors période ; l'aperçu admin réutilise appliquerPalette + Decor.
const VARS = { fond: "--mt-ink", cartes: "--mt-surface", accent: "--mt-gold",
               accent_clair: "--mt-champagne", texte: "--mt-ivory" };

export function appliquerPalette(palette) {
  const racine = document.documentElement;
  for (const [cle, varCss] of Object.entries(VARS)) {
    if (/^#[0-9A-Fa-f]{6}$/.test((palette || {})[cle] || "")) {
      racine.style.setProperty(varCss, palette[cle]);
    }
  }
}

export function retirerPalette() {
  Object.values(VARS).forEach((v) => document.documentElement.style.removeProperty(v));
}

// CURSEUR FESTIF (demande du propriétaire, 2026-10-27) : pendant le thème, la
// flèche de la souris devient une forme de la fête choisie dans une LISTE —
// Halloween : citrouille, fantôme, bonbon… ; Noël : cadeau, canne de bonbon,
// lumière de Noël… Curseur SVG « en données » (aucune image externe, aucun
// tiers) ; point chaud au centre (16,16). Liste partagée avec la carte admin.
const _emo = (e) =>
  `url("data:image/svg+xml;charset=utf-8,${encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32"><text x="2" y="25" font-size="25">${e}</text></svg>`)}") 16 16, auto`;
const _svg = (dessin) =>
  `url("data:image/svg+xml;charset=utf-8,${encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32">${dessin}</svg>`)}") 16 16, auto`;
// Canne de bonbon et lumière de Noël dessinées à la main (pas d'émoji dédié)
const _CANNE = _svg(
  `<path d="M13 29 V11 a6.5 6.5 0 0 1 13 0" fill="none" stroke="#ffffff" stroke-width="6.5" stroke-linecap="round"/>` +
  `<path d="M13 29 V11 a6.5 6.5 0 0 1 13 0" fill="none" stroke="#d22630" stroke-width="6.5" stroke-linecap="round" stroke-dasharray="4.5 4.5"/>`);
const _LUMIERE = _svg(
  `<rect x="13" y="1.5" width="6" height="5" rx="1.5" fill="#5a5a5a"/>` +
  `<path d="M16 6 C9 6 7 11.5 7 16 a9 9 0 0 0 18 0 C25 11.5 23 6 16 6 Z" fill="#ffcf3f" stroke="#c9862b" stroke-width="1.5"/>` +
  `<circle cx="16" cy="16" r="12" fill="#ffcf3f" opacity="0.18"/>`);
export const CURSEURS = [
  ["aucun", "Aucun (flèche normale)"],
  ["citrouille", "Citrouille", _emo("🎃")],
  ["fantome", "Fantôme", _emo("👻")],
  ["bonbon", "Bonbon", _emo("🍬")],
  ["chauve-souris", "Chauve-souris", _emo("🦇")],
  ["crane", "Crâne", _emo("💀")],
  ["araignee", "Araignée", _emo("🕷️")],
  ["cadeau", "Cadeau", _emo("🎁")],
  ["canne", "Canne de bonbon", _CANNE],
  ["lumiere", "Lumière de Noël", _LUMIERE],
  ["flocon", "Flocon de neige", _emo("❄️")],
  ["sapin", "Sapin de Noël", _emo("🎄")],
  ["renne", "Renne", _emo("🦌")],
  ["cloche", "Cloche", _emo("🔔")],
  ["etoile", "Étoile", _emo("⭐")],
  ["coeur", "Cœur (Saint-Valentin)", _emo("❤️")],
  ["lapin", "Lapin de Pâques", _emo("🐰")],
  ["oeuf", "Œuf de Pâques", _emo("🥚")],
  ["trefle", "Trèfle (Saint-Patrick)", _emo("☘️")],
  ["erable", "Feuille d'érable", _emo("🍁")],
  ["dinde", "Dinde (Action de grâce)", _emo("🦃")],
  ["feu-artifice", "Feu d'artifice", _emo("🎆")],
  ["ballon", "Ballon de fête", _emo("🎈")],
  ["fleur", "Fleur (printemps)", _emo("🌸")],
  ["soleil", "Soleil (été)", _emo("☀️")],
  ["trophee", "Trophée", _emo("🏆")],
  ["medaille", "Médaille", _emo("🏅")],
];
const _CURSEUR_ID = "mt-curseur-festif";
export function appliquerCurseur(type, imgPath) {
  retirerCurseur();
  // Curseur DESSINÉ PAR GEMINI (demande du propriétaire, 2026-10-27) : l'image
  // 32×32 à fond transparent a priorité sur la forme émoji choisie
  let css = null;
  if (imgPath) {
    css = `url("${process.env.REACT_APP_BACKEND_URL}/api/files/${imgPath}") 16 16, auto`;
  } else {
    css = (CURSEURS.find(([v]) => v === type) || [])[2];
  }
  if (!css) return;
  const el = document.createElement("style");
  el.id = _CURSEUR_ID;
  el.textContent = `* { cursor: ${css} !important; }`;
  document.head.appendChild(el);
}
export function retirerCurseur() {
  document.getElementById(_CURSEUR_ID)?.remove();
}

// Guirlande d'ampoules scintillantes en haut de page (CSS pur) — le plus
// festif des décors : une ligne d'ampoules colorées qui brillent en alternance
function Guirlande() {
  const COULEURS = ["#ff5f56", "#ffd166", "#7bd88f", "#6ec1ff", "#ff9de2"];
  return (
    <div aria-hidden="true" className="fixed top-0 left-0 right-0 pointer-events-none z-[5] h-14 overflow-hidden">
      {Array.from({ length: 26 }, (_, i) => {
        const x = (i + 0.5) * (100 / 26);
        const creux = Math.sin((i / 25) * Math.PI * 4);            // vague de la guirlande
        const y = 10 + Math.abs(creux) * 14;
        return (
          <span key={i} style={{
            position: "absolute", left: `${x}%`, top: y,
            width: 7, height: 10, borderRadius: "50% 50% 50% 50% / 60% 60% 40% 40%",
            background: COULEURS[i % COULEURS.length],
            boxShadow: `0 0 10px 3px ${COULEURS[i % COULEURS.length]}88`,
            animation: `mt-ampoule ${1.6 + (i % 3) * 0.5}s ease-in-out ${(i % 5) * 0.3}s infinite`,
          }} />
        );
      })}
    </div>
  );
}

// Couche décorative festive (CSS pur + émojis, pointer-events: none, sous les
// modales) — chaque option rend le site visiblement plus festif :
//   neige     : gros flocons denses qui tombent en oscillant
//   feuilles  : feuilles d'automne orange/rouille/or qui tournent en tombant
//   etoiles   : ciel d'étoiles scintillantes + quelques grandes étoiles
//   bokeh     : grosses lueurs festives colorées qui montent doucement
//   guirlande : ampoules colorées scintillantes en haut de page
//   confettis : pluie de confettis rectangulaires multicolores
// 2026-10-27 (demande du propriétaire : « plus de décor pour les fêtes
// régulières — des bonbons qui tombent au lieu des feuilles — et une 2e
// option comme les bonbons ET les feuilles ») : décors d'ÉMOJIS qui tombent
// (bonbons, cœurs, œufs de Pâques, trèfles, érables) ou montent (ballons),
// et DÉCORS COMBINÉS (deux couches à la fois).
const DECOR_CSS = `
    @keyframes mt-tombe { 0% { transform: translateY(-8vh) translateX(0) rotate(0deg); } 50% { transform: translateY(50vh) translateX(4vw) rotate(180deg); } 100% { transform: translateY(108vh) translateX(-2vw) rotate(360deg); } }
    @keyframes mt-scintille { 0%, 100% { opacity: .12; transform: scale(.7); } 50% { opacity: 1; transform: scale(1.25); } }
    @keyframes mt-monte { 0% { transform: translateY(104vh) scale(.8); opacity: 0; } 15% { opacity: .3; } 85% { opacity: .3; } 100% { transform: translateY(-24vh) scale(1.1); opacity: 0; } }
    @keyframes mt-monte-plein { 0% { transform: translateY(104vh) rotate(-6deg); opacity: 0; } 10% { opacity: .95; } 88% { opacity: .95; } 100% { transform: translateY(-20vh) rotate(6deg); opacity: 0; } }
    @keyframes mt-ampoule { 0%, 100% { opacity: .45; } 50% { opacity: 1; } }
  `;
const CONF = ["#ff5f56", "#ffd166", "#7bd88f", "#6ec1ff", "#ff9de2", "#f4a261"];
// Décors en FORMES CSS colorées
const GRAINS_FORMES = {
  neige:     { n: 44, taille: [3, 9],  forme: "50%",           couleurs: ["#ffffff"], op: 0.9,  anim: "mt-tombe",     duree: [7, 15] },
  feuilles:  { n: 30, taille: [7, 14], forme: "60% 0 60% 0",   couleurs: ["#e07b2a", "#c23b22", "#d9a441"], op: 0.9, anim: "mt-tombe", duree: [8, 14] },
  etoiles:   { n: 38, taille: [2, 5],  forme: "50%",           couleurs: ["#ffe9a8", "#fff7dd", "#ffd166"], op: 1, anim: "mt-scintille", duree: [2, 5] },
  bokeh:     { n: 14, taille: [26, 70], forme: "50%",          couleurs: ["#d4af37", "#c8372d", "#2d6a4f", "#ffd166"], op: 1, anim: "mt-monte", duree: [14, 24] },
  confettis: { n: 42, taille: [6, 11], forme: "2px",           couleurs: CONF, op: 0.95, anim: "mt-tombe", duree: [5, 10] },
};
// Décors en ÉMOJIS (fêtes régulières — demande du propriétaire, 2026-10-27)
const GRAINS_EMOJI = {
  bonbons: { n: 26, taille: [15, 24], emojis: ["🍬", "🍭", "🍫"], anim: "mt-tombe", duree: [7, 13] },
  coeurs:  { n: 26, taille: [14, 23], emojis: ["❤️", "💖", "💕"], anim: "mt-tombe", duree: [7, 13] },
  paques:  { n: 26, taille: [14, 22], emojis: ["🥚", "🐣", "🐰"], anim: "mt-tombe", duree: [7, 13] },
  trefles: { n: 24, taille: [13, 21], emojis: ["☘️", "🍀"], anim: "mt-tombe", duree: [8, 14] },
  erables: { n: 26, taille: [15, 24], emojis: ["🍁"], anim: "mt-tombe", duree: [8, 14] },
  ballons: { n: 14, taille: [20, 32], emojis: ["🎈", "🎈", "🎉"], anim: "mt-monte-plein", duree: [12, 20] },
};
// Tous les choix valides (partagé avec la carte admin et le backend)
export const DECORS_VALIDES = ["aucun", ...Object.keys(GRAINS_FORMES), "guirlande",
                               ...Object.keys(GRAINS_EMOJI)];

// UNE couche de décor (forme CSS, émoji ou guirlande)
// facteur : dose la QUANTITÉ (« pluie légère / moyenne / forte » — demande du
// propriétaire, 2026-10-27) ; la guirlande, fixe en haut de page, n'est pas dosée
function Couche({ type, facteur = 1 }) {
  if (type === "guirlande") return <Guirlande />;
  // Décor DESSINÉ PAR GEMINI (demande du propriétaire, 2026-10-27 : « images
  // de décor générées ») : PNG à fond TRANSPARENT (détourage au serveur) —
  // flotte proprement sur tout arrière-plan, même le fond d'ambiance lumineux
  if (type.startsWith("img:")) {
    const src = `${process.env.REACT_APP_BACKEND_URL}/api/files/${type.slice(4)}`;
    return Array.from({ length: Math.max(6, Math.round(18 * facteur)) }, (_, i) => {
      const taille = 18 + (((i * 37) % 100) / 100) * 20;
      const duree = 7 + ((i * 13) % 10) / 10 * 6;
      return (
        <img key={i} src={src} alt="" aria-hidden="true" style={{
          position: "absolute", left: `${(i * 41) % 100}%`, top: `${-((i * 7) % 100)}%`,
          width: taille, height: taille, objectFit: "contain", opacity: 0.95,
          animation: `mt-tombe ${duree}s linear ${-((i * 17) % 120) / 10}s infinite`,
        }} />
      );
    });
  }
  const G = GRAINS_FORMES[type];
  if (G) {
    return Array.from({ length: Math.max(6, Math.round(G.n * facteur)) }, (_, i) => {
      const taille = G.taille[0] + (((i * 37) % 100) / 100) * (G.taille[1] - G.taille[0]);
      const couleur = G.couleurs[i % G.couleurs.length];
      const duree = G.duree[0] + ((i * 13) % 10) / 10 * (G.duree[1] - G.duree[0]);
      const base = {
        position: "absolute", left: `${(i * 41) % 100}%`,
        width: type === "confettis" ? taille * 0.55 : taille, height: taille,
        borderRadius: G.forme, background: couleur, opacity: G.op,
        animation: `${G.anim} ${duree}s linear ${-((i * 17) % 120) / 10}s infinite`,
      };
      if (type === "bokeh") base.boxShadow = `0 0 ${taille}px ${taille / 2.5}px ${couleur}55`;
      if (type === "etoiles") base.boxShadow = `0 0 8px 2px ${couleur}66`;
      base.top = type === "etoiles" ? `${(i * 29) % 100}%` : `${-((i * 7) % 100)}%`;
      return <span key={i} style={base} />;
    });
  }
  const E = GRAINS_EMOJI[type];
  if (E) {
    return Array.from({ length: Math.max(5, Math.round(E.n * facteur)) }, (_, i) => {
      const taille = E.taille[0] + (((i * 37) % 100) / 100) * (E.taille[1] - E.taille[0]);
      const duree = E.duree[0] + ((i * 13) % 10) / 10 * (E.duree[1] - E.duree[0]);
      return (
        <span key={i} style={{
          position: "absolute", left: `${(i * 41) % 100}%`,
          top: E.anim === "mt-monte-plein" ? `${-((i * 7) % 40)}%` : `${-((i * 7) % 100)}%`,
          fontSize: taille, lineHeight: 1, opacity: 0.95, filter: "drop-shadow(0 2px 3px rgba(0,0,0,.35))",
          animation: `${E.anim} ${duree}s linear ${-((i * 17) % 120) / 10}s infinite`,
        }}>{E.emojis[i % E.emojis.length]}</span>
      );
    });
  }
  return null;
}

// Décors MULTIPLES en cases à cocher (demande du propriétaire, 2026-10-27) :
// `type` accepte une LISTE — toutes les couches cochées jouent en même temps
// (ex. bonbons + feuilles ensemble) ; une chaîne seule reste acceptée.
// `densite` : plusieurs choix de pluie (demande du propriétaire, 2026-10-27) —
// de la bruine discrète à la TEMPÊTE (× 3 la pluie forte, comme demandé)
const DENSITE_FACTEUR = { "tres-legere": 0.3, legere: 0.55, moyenne: 1, forte: 1.8, tempete: 5.4 };
export function Decor({ type, densite }) {
  const couches = (Array.isArray(type) ? type : [type]).filter((d) => d && d !== "aucun");
  if (!couches.length) return null;
  const facteur = DENSITE_FACTEUR[densite] || 1;
  return (
    <div aria-hidden="true" data-testid="theme-decor" data-decor={couches.join("+")}
      data-densite={densite || "moyenne"}
      className="fixed inset-0 pointer-events-none z-[5] overflow-hidden">
      <style>{DECOR_CSS}</style>
      {couches.map((c) => <Couche key={c} type={c} facteur={facteur} />)}
    </div>
  );
}

// APERÇU ADMIN partagé (demande du propriétaire, 2026-10-27) : la carte des
// thèmes demande la visualisation d'un thème par ce canal — UNE seule couche
// de décor existe alors (le décor du vrai thème se tait pendant l'aperçu ;
// plus jamais feuilles + neige superposées)
export function apercuLocalTheme(themeOuNull) {
  window.dispatchEvent(new CustomEvent("mt-theme-apercu", { detail: themeOuNull || null }));
}

export default function ThemeSaison() {
  const [theme, setTheme] = useState(null);
  const [apercu, setApercu] = useState(null);
  const apercuRef = useRef(false);
  apercuRef.current = !!apercu;

  const poser = (th) => {
    if (th && th.palette) appliquerPalette(th.palette); else retirerPalette();
    if (th) appliquerCurseur(th.curseur, th.curseur_img); else retirerCurseur();
  };

  // RELECTURE TOUTE SEULE toutes les 60 s (plainte du propriétaire, 2026-10-27 :
  // « lorsque l'on applique un thème comme Noël, les feuilles continuent de
  // tomber ») — sans rechargement : un thème forcé dans l'admin, sa libération
  // ou la fin d'une période remplacent palette + décor + curseur d'eux-mêmes
  useEffect(() => {
    let monte = true;
    const charger = () => api.get("/theme-saison").then(({ data }) => {
      if (!monte || apercuRef.current) return;   // l'aperçu admin a la main
      const th = data && data.actif ? data.theme : null;
      setTheme(th);
      poser(th);
    }).catch(() => {});
    charger();
    const minuteur = setInterval(charger, 60000);
    const surApercu = (e) => {
      const t = e.detail || null;
      setApercu(t);
      if (t) poser(t);       // le thème demandé remplace tout, ici même
      else charger();        // « Quitter l'aperçu » : le vrai thème revient
    };
    window.addEventListener("mt-theme-apercu", surApercu);
    return () => {
      monte = false;
      clearInterval(minuteur);
      window.removeEventListener("mt-theme-apercu", surApercu);
      retirerPalette();
      retirerCurseur();
    };
  }, []);
  const affiche = apercu || theme;
  if (!affiche) return null;
  return (
    <>
      {/* FOND D'ACCUEIL festif dessiné par Gemini (demande du propriétaire,
          2026-10-27) : grand voile d'ambiance à 14 % en fusion « screen » —
          visible partout, le texte reste parfaitement lisible */}
      {affiche.fond_img && (
        <div aria-hidden="true" data-testid="theme-fond"
          className="fixed inset-0 z-[3] pointer-events-none overflow-hidden">
          <img src={`${process.env.REACT_APP_BACKEND_URL}/api/files/${affiche.fond_img}`} alt=""
            className="w-full h-full object-cover opacity-[0.14]" style={{ mixBlendMode: "screen" }} />
        </div>
      )}
      <Decor type={affiche.decor} densite={affiche.densite} />
    </>
  );
}
